import { render } from "./DataProtection.vue?vue&type=template&id=5cb00286"
import script from "./DataProtection.vue?vue&type=script&lang=js"
export * from "./DataProtection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__